<template>
  <div>
    <b-form-group label="Должность">
      <b-form-input
        v-model="value.position"
        type="text"
        placeholder="Введите должность"
      ></b-form-input>
    </b-form-group>
    <b-form-group label="Табельный номер">
      <b-form-input
        v-model="value.personnel_number"
        type="text"
        placeholder="Введите табельный номер"
      ></b-form-input>
    </b-form-group>
    <b-form-group label="Служба">
      <b-form-select
        v-model="value.service_id"
        :options="servicesOptions"
        required
      ></b-form-select>
    </b-form-group>
  </div>
</template>

<script>
import EmployeeModel from "@/components/Forms/Person/models/employeeModel";
import { mapGetters } from "vuex";

export default {
  props: {
    value: {
      type: EmployeeModel,
      required: false,
      default: () => new EmployeeModel()
    }
  },
  computed: {
    ...mapGetters("services", ["actualServices"]),
    servicesOptions: ({ actualServices }) => {
      return [
        {
          text: "Нет",
          value: null
        },
        ...actualServices.map(service => ({
          text: service.name,
          value: service.id
        }))
      ];
    }
  }
};
</script>
